var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-a4',{attrs:{"orientation":_vm.orientation,"is-loading":_vm.isLoading}},[(_vm.dados && _vm.dados.template)?_c('div',{attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.dados.template.template)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }